import { UserType } from 'Core/interfaces/core'

import { LayoutType } from 'Portals/Supplier/constants/layout'

export const LAYOUT_TYPE_USER_TYPE_DEPENDENCIES: {
	[key in UserType]?: LayoutType
} = {
	[UserType.SUPPLIER]: LayoutType.general,
	[UserType.ACCOUNTS_PAYABLE]: LayoutType.general,
	[UserType.NEW_SUPPLIER]: LayoutType.registrationDocument
}
